import { create } from "zustand/react";
import type { SignalWrapper } from "@/helpers/signalr/signalr.ts";
import { HubConnectionState } from "@microsoft/signalr";
import { SignalInvoke, type SignalOn } from "@/types/signalr-functions.ts";

export type SignalStore = {
  signalr: SignalWrapper<SignalOn, SignalInvoke> | null;
  status: HubConnectionState;
  Create: (wrapper: SignalWrapper<SignalOn, SignalInvoke>) => void;
  Remove: () => void;
  SetStatus: (status: HubConnectionState) => void;
};

export const useSignalStore = create<SignalStore>()((set) => ({
  signalr: null,
  status: HubConnectionState.Disconnected,
  Create: (wrapper) =>
    set(() => ({
      signalr: wrapper,
    })),
  Remove: () => set(() => ({ signalr: null })),
  SetStatus: (status: HubConnectionState) => {
    set(() => ({
      status,
    }));
  },
}));
